
<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>退票信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="工单编号：">{{params.purchaseContractInvoiceSubDetailVo.subNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类型：">{{params.purchaseContractInvoiceSubDetailVo.subType ===1?'红字发票':'普通发票'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票类型：">{{params.purchaseContractInvoiceSubDetailVo.invoiceType}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="公司名称："
              >{{params.purchaseContractInvoiceSubDetailVo.suName}}</el-form-item
            >
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联发票编号：">{{params.purchaseContractInvoiceSubDetailVo.invoiceNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{params.purchaseContractInvoiceSubDetailVo.createDate |dateFilter}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="退票原因：">{{params.purchaseContractInvoiceSubDetailVo.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>票据信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="退票状态：">{{switchState(params.purchaseContractInvoiceSubDetailVo)}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额：">{{params.purchaseContractInvoiceSubDetailVo.amount | toFixed}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票税额：">{{params.purchaseContractInvoiceSubDetailVo.taxAmounts | toFixed}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="发票编号："
              v-show="params.purchaseContractInvoiceSubDetailVo.subType ===1 "
              >{{params.purchaseContractInvoiceSubDetailVo.invoiceRedNumber}}</el-form-item
            >
          </el-col>
          <el-col :span="8" v-show="params.purchaseContractInvoiceSubDetailVo.state !== 1 && params.purchaseContractInvoiceSubDetailVo.state !== 0">
            <el-form-item label="处理人：">{{params.purchaseContractInvoiceSubDetailVo.staffCnName}}</el-form-item>
          </el-col>
          <el-col :span="8" v-show="params.purchaseContractInvoiceSubDetailVo.state !== 1 && params.purchaseContractInvoiceSubDetailVo.state !== 0">
            <el-form-item label="退票时间：">{{params.purchaseContractInvoiceSubDetailVo.processDate |dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票人：">{{params.purchaseContractInvoiceSubDetailVo.receivePeople}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{params.purchaseContractInvoiceSubDetailVo.receivePhone}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收票地址："
              >{{params.purchaseContractInvoiceSubDetailVo.receiveAddress}}</el-form-item
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>产品详情</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="params.purchaseContractInvoiceSubDetailProductVoList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        height="378"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="pcbNumber" label="采购合同编号"></el-table-column>
        <el-table-column
          prop="supplierContractNumber"
          label="供应商合同编号"
          width="120px"
        ></el-table-column>
        <el-table-column prop="proName" label="产品名称"></el-table-column>
        <el-table-column prop="proModel" label="型号"></el-table-column>
        <el-table-column prop="proOrdernum" label="订货号"></el-table-column>
        <el-table-column prop="proUnit" label="单位"></el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
        <el-table-column prop="purchasePrice" label="实付单价"></el-table-column>
        <el-table-column prop="actualTotal" label="实付总额"></el-table-column>
        <el-table-column prop="taxRate" label="税率">
            <template slot-scope="scope">
                <div>
                  {{ scope.row.taxRate *100 }}%
                </div>
              </template>
        </el-table-column>
        <el-table-column prop="taxAmount" label="税额">
          <template slot-scope="scope">{{scope.row.taxAmount | toFixed}}</template>
        </el-table-column>
      </el-table>
    </div>
    <!-------------- 工单日志 -------------->
    <operation-log-and-flow :flowLabel="flowLabel"></operation-log-and-flow>
  </div>
</template>
<script>
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import { queryInvoiceSubDetail } from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'

export default {
  components: {
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      state: ['未提交', '审核中', '已通过', '已拒绝'],
      params: {
        purchaseContractInvoiceSubDetailVo: {
          subNumber: '',
          subType: 1,
          invoiceType: '',
          suName: '',
          invoiceNumber: '',
          createDate: '',
          mark: '',
          state: '',
          amount: 150,
          taxAmounts: 30.15,
          invoiceRedNumber: null,
          staffCnName: null,
          processDate: '',
          receivePeople: '',
          receivePhone: '',
          receiveAddress: ''
        },
        purchaseContractInvoiceSubDetailProductVoList: []
      },
      list: [],
      loadingTable: false,
      flowLabel: '退票流程'
    }
  },
  mounted () {
    queryInvoiceSubDetail(this.$route.query.pcisId)
      .then(res => {
        if (res.data.code === 200) {
          this.params = res.data.obj
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    switchState(row) {
      const {
        subType,
        state
      } = row
      if (subType !== 1) {
        switch (state) {
          case 3:
          case 5:
            return '审核不通过'
          case 4:
            return '已退票'
          default:
            return '退票审核'
        }
      } else {
        return this.inState1(state)
      }
    },
    inState1: (value) => {
      switch (value) {
        case 0:
        case 1:
          return '申请审核'
        case 6:
          return '待收票'
        case 4:
          return '已收票'
        case 3:
        case 5:
          return '审核不通过'
        default:
          return '开具红字信息表'
      }
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  const date = new Date(time)
  // eslint-disable-next-line no-undef
  return formatDate(date, 'yyyy-MM-dd hh:mm')
}
</script>
